// ui
import { Box, Alert } from "@mui/material";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import AddIcCallIcon from "@mui/icons-material/AddIcCall";

// ★cmd-po_1139: PoModalShell + PoButton で catalog 外殻を導入
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";

interface FollowCallStartStopModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  startStopDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  };
  setStartStopDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }) => void;
  startStopData: () => void;
}

export function FollowCallStartStopModal(props: FollowCallStartStopModalProps) {
  const {
    onModal,
    swCloseModal,
    startStopDataInf,
    setStartStopDataInf,
    startStopData,
  } = props;

  const footer =
    startStopDataInf.status === "open" ? (
      <>
        <PoButton
          variant="secondary"
          data-testid="follow-call-start-stop-close"
          onClick={swCloseModal}
        >
          閉じる
        </PoButton>
        {/* ★殿裁定(alert_20260825_followcall_stop_warning_hex): stop時のwarning色をカタログトークン var(--sem-warning) へ */}
        <PoButton
          variant="primary"
          data-testid="follow-call-start-stop-submit"
          onClick={startStopData}
          sx={
            startStopDataInf.key.startStop === "stop"
              ? {
                  backgroundColor: "var(--sem-warning)",
                  border: "1px solid var(--sem-warning)",
                  "&:hover": { backgroundColor: "var(--sem-warning)" },
                }
              : {}
          }
        >
          {startStopDataInf.key.startStop === "start" ? "再開" : "停止"}
          {startStopDataInf.key.startStop === "start" ? (
            <AddIcCallIcon fontSize="small" />
          ) : (
            <DoDisturbAltIcon fontSize="small" />
          )}
        </PoButton>
      </>
    ) : startStopDataInf.status === "success" ? (
      <PoButton
        variant="secondary"
        data-testid="follow-call-start-stop-success-close"
        onClick={swCloseModal}
      >
        閉じる
      </PoButton>
    ) : startStopDataInf.status === "failed" ? (
      <PoButton
        variant="secondary"
        data-testid="follow-call-start-stop-failed-back"
        onClick={() =>
          setStartStopDataInf({
            ...startStopDataInf,
            status: "open",
            message: "",
          })
        }
      >
        戻る
      </PoButton>
    ) : null;

  return (
    <PoModalShell
      open={onModal}
      title="フォローコール停止・再開"
      onClose={swCloseModal}
      testidPrefix="follow-call-start-stop"
      footer={footer}
    >
      {startStopDataInf.status === "open" ? (
        <>
          {/* ★保全ガード③: start⇔stop文言/アイコン/警告色切替は不可触 */}
          <Alert
            severity="error"
            sx={{
              bgcolor: "var(--sem-error-bg, #f6d5d1)",
              color: "var(--sem-error, #a53229)",
              fontSize: 12,
              borderRadius: "var(--radius-md, 10px)",
              p: "var(--sp-3, 12px) var(--sp-4, 16px)",
              "& .MuiAlert-icon": { color: "var(--sem-error, #a53229)" },
            }}
          >
            {startStopDataInf.key.startStop === "start"
              ? "ステータスを「フォローコール未実施」に変更します。"
              : startStopDataInf.key.startStop === "stop"
              ? "ステータスを「フォローコールを行わない」に変更します。"
              : null}
          </Alert>
        </>
      ) : startStopDataInf.status === "success" ? (
        <Box className="result-state -success" data-testid="result-state-success">
          <span className="rs-title">成功しました。</span>
        </Box>
      ) : startStopDataInf.status === "failed" ? (
        <Box className="result-state -failed" data-testid="result-state-failed">
          <span className="rs-title">{startStopDataInf.message}</span>
        </Box>
      ) : null}
    </PoModalShell>
  );
}
